import { RouterPages } from 'shared/model/routes'

import { Suspense } from 'react'

import { Navigate, RouteObject } from 'react-router-dom'

import { LoginLazy } from 'routes/Auth/routes'

import { ContentLoader } from 'shared/ui/ContentLoader'

import { Auth } from './ui/Auth'

export const authRoutes: RouteObject[] = [
  {
    path: 'auth',
    element: (
      <Suspense fallback={<ContentLoader />}>
        <Auth />
      </Suspense>
    ),
    children: [
      {
        path: 'login',
        element: <LoginLazy />,
      },
    ],
  },
  {
    path: 'auth/',
    element: <Navigate to={RouterPages.login} />,
  },
]
